package one.healthium.uscreen.domain.models

import kotlinx.serialization.ExperimentalSerializationApi
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import kotlinx.serialization.json.JsonClassDiscriminator

@OptIn(ExperimentalSerializationApi::class)
@Serializable
@JsonClassDiscriminator("type")
sealed interface UScreenBackground

@Serializable
@SerialName("gradient")
data class GradientBackground(
    @SerialName("colors") val colors: List<String>,
    @SerialName("direction") val direction: GradientDirection = GradientDirection.TopToBottom,
    @SerialName("transition") val transition: BlockTransition? = null,
) : UScreenBackground

@Serializable
@SerialName("solid")
data class SolidBackground(
    @SerialName("color") val color: String,
    @SerialName("transition") val transition: BlockTransition? = null,
) : UScreenBackground

@Serializable
@SerialName("theme")
data object ThemeBackground : UScreenBackground

@Serializable
enum class GradientDirection {
    @SerialName("topToBottom") TopToBottom,
    @SerialName("leftToRight") LeftToRight,
}
